const emailJSConfig = {
    USER_ID: process.env.REACT_APP_EMAILJS_USERID || '',
    TEMPLATE_ID: `template_2jdgwyn`,
    SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICEID || '',
};
export default emailJSConfig;
